<template>
  <tr>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row" />
    <td
      v-for="filter in filters"
      :key="filter.field"
      class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
    >
      <v-text-field
        v-if="filter.type === 'text'"
        :label="filter.label"
        v-model="searchData[filter.field]"
        type="text"
        @keyup.enter="resetToFirstPage"
        hide-details="true"
        dense
        prepend-inner-icon="mdi-magnify"
        clearable
        @click:clear="clearFilterData(filter.field)"
      />
      
      <v-menu
        v-else-if="filter.type === 'date'"
        v-model="filter.menu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            :label="filter.label"
            v-model="filter.formatted"
            v-bind="attrs"
            @blur="updateDateValue(filter.field, filter.formatted)"
            v-on="on"
            hide-details="true"
            dense
            clearable
            @click:clear="clearFilterData(filter.field)"
          />
        </template>
        <v-date-picker
          v-model="searchData[filter.field]"
          no-title
          :max="today"
          scrollable
          @input="closeMenu(filter.field)"
        >
        <v-spacer />
          <v-btn text color="primary" @click="closeMenu(filter.field)">Cancel</v-btn>
        </v-date-picker>
      </v-menu>


      <v-select
        v-else-if="filter.type === 'select'"
        :label="filter.label"
        v-model="searchData[filter.field]"
        :items="filter.items"
        item-text="text"
        item-value="value"
        @change="resetToFirstPage"
        clearable
        hide-details="true"
        dense
      />
    </td>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row" />
  </tr>
</template>

<script>
import { formatDate, parseDate } from '../../../../lib/helpers';
import { dataListHistoryRmStatus, dataListMerchantType, dataListTaskType } from '../../../../store/params';

export default {
  props: ['search', 'options'],
  data() {
    return {
      filters: [
        { label: 'Nama', field: 'merchant_name', type: 'text' },
        { label: 'MID', field: 'mid', type: 'text' },
        { label: 'Type', field: 'merchant_type', type: 'select', items: dataListMerchantType },
        { label: 'Alamat Lengkap', field: 'address', type: 'text' },
        { label: 'Nomor Pengajuan', field: 'reference_number', type: 'text',},
        { label: 'Request Date', field: 'created_at', type: 'date', menu: false, formatted: '' },
        { label: 'Last Update', field: 'updated_at', type: 'date', menu: false, formatted: '' },
        { label: 'Jenis Pengajuan', field: 'task_type', type: 'select', items: dataListTaskType },
        { label: 'Status', field: 'status', type: 'select', items: dataListHistoryRmStatus },
      ],
      
      suppressWatch: false,
    };
  },
  computed: {
    today() {
      return new Date().toLocaleDateString('sv-SE');
    },
    searchData: {
      get() {
        return this.search;
      },
      set(newValue) {
        this.$emit('update:search', newValue);
      },
    },
  },
  watch: {
    'searchData.created_at': {
      handler(newVal) {
        if (this.suppressWatch) return;
        const dateFilter = this.filters.find(f => f.field === 'created_at');
        if (dateFilter) {
          dateFilter.formatted = formatDate(newVal);
        }
        this.resetToFirstPage();
      },
    },
    'searchData.updated_at': {
      handler(newVal) {
        if (this.suppressWatch) return;
        const dateFilter = this.filters.find(f => f.field === 'updated_at');
        if (dateFilter) {
          dateFilter.formatted = formatDate(newVal);
        }
        this.resetToFirstPage();
      },
    },
  },
  beforeDestroy() {
    this.resetFilters();
  },
  methods: {
    resetFilters() {
      Object.keys(this.searchData).forEach(key => {
        this.searchData[key] = '';
      });
    },
    clearFilterData(field) {
      this.suppressWatch = true;

      this.searchData[field] = '';
      const dateFilter = this.filters.find(f => f.field === field);
      if (dateFilter && dateFilter.type === 'date') {
        dateFilter.formatted = '';
      }

      this.$nextTick(() => {
        this.suppressWatch = false;
        this.resetToFirstPage();
      });
    },
    updateDateValue(field, formattedValue) {
      const parsedDate = parseDate(formattedValue);
      if (parsedDate) {
        this.searchData[field] = parsedDate;
      }
    },
    closeMenu(field) {
      const dateFilter = this.filters.find(f => f.field === field);
      if (dateFilter) {
        this.$set(dateFilter, 'menu', false);
      }
    },
    resetToFirstPage() {
      this.$emit('update:options', {
        ...this.options,
        page: 1,
      });
    },
    getData() {
      const newOptions = { ...this.options, page: 1 };
      this.$emit('update:options', newOptions);
      this.$emit('getDataParent');
    },
  },
};
</script>